export default "__VITE_ASSET__BaHYanf___"